import { baseApi } from "../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../core/data/rtk/apiResponseType";
import { DashboardResponse, CourseOverviewResponse, BookRequestsResponse, ChartsInfoResponse } from "../types/DashboardResponse";

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardData: builder.query<ApiResponseType<DashboardResponse>, void>({
      query: () => `dashboard/get-data`,
    //   providesTags: ["Dashboard"],
    }),
    getCourseOverview: builder.query<ApiResponseType<CourseOverviewResponse>, { center_id?: number }>({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.center_id) queryParams.append("center_id", params.center_id.toString());
        return `dashboard/course-overview?${queryParams.toString()}`;
      },
    }),
    getBookRequestsSummary: builder.query<ApiResponseType<BookRequestsResponse>, { center_id?: number }>({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.center_id) queryParams.append("center_id", params.center_id.toString());
        return `dashboard/book-requests?${queryParams.toString()}`;
      },
    }),
    getChartsInfo: builder.query<ApiResponseType<ChartsInfoResponse>, { center_id?: number }>({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.center_id) queryParams.append("center_id", params.center_id.toString());
        return `dashboard/charts-info?${queryParams.toString()}`;
      },
    }),
  }),
});

export const {
    useGetDashboardDataQuery,
    useGetCourseOverviewQuery,
    useGetBookRequestsSummaryQuery,
    useGetChartsInfoQuery,
} = dashboardApi;
